export default "__VITE_ASSET__CD$oY0yg__"